<script lang="ts">
    import Text from '../../../Text.svelte';
    import InterestList from '../../InterestList.svelte';
    import { interestListFormatter } from '../../../../utils';
    import { interests as interestList } from '../../../../stores';

    export let row: any;
</script>

<div class="abcde">
    {#if !((row.lookalikeId !== '' && row.lookalikeId !== null) || (row.targetId !== '' && row.targetId !== null))}
        {#if JSON.parse(row.abcde).length > 0}
            <Text type="body1">{row.abcdeCertainty * 100}%</Text>
            <InterestList
            operator={"OR"}
            interestList={interestListFormatter(row.abcde, $interestList)}
            />
        {/if}
    {/if}
</div>

<style>
    .abcde {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    }
</style>
